import openToWorkApi from "@/api/art-order/openToWork/client";
import { useQuery } from "@tanstack/react-query";

function useOrdersForOpenToWorkArtist(artistId: string) {
  const { data: artOrders } = useQuery({
    queryKey: ["orders-for-otw-artists", artistId],
    queryFn: () => {
      return openToWorkApi.getOrdersForOpenToWorkArtists(artistId);
    },
  });

  return { artOrders };
}

export default useOrdersForOpenToWorkArtist;
